import { FileText, Images, PlusSquare, ArrowRight, Lock } from 'lucide-react';

const SOURCES = [
  {
    id: 'photos',
    icon: Images,
    eyebrow: 'Recommandé sans CCTP',
    title: 'Photos 3D intérieures',
    desc: "L'IA détecte la pièce, identifie chaque revêtement visible et découpe une vignette par matériau.",
    needsProject: true,
    accent: true,
  },
  {
    id: 'cctp',
    icon: FileText,
    eyebrow: 'Document technique',
    title: 'CCTP / Carnet de détails',
    desc: 'Extraction exhaustive des prescriptions (références, formats, finitions) depuis le PDF.',
    needsProject: false,
  },
  {
    id: 'blank',
    icon: PlusSquare,
    eyebrow: 'Manuel',
    title: 'Matériauthèque vierge',
    desc: 'Démarrer à vide et saisir les matériaux un à un. Un CCTP pourra enrichir la liste plus tard.',
    needsProject: true,
  },
];

export const SourceChooser = ({ hasProject, onPick, busy }) => (
  <div className="max-w-5xl mx-auto hud-stagger">
    <div className="mb-6">
      <span className="hud-eyebrow hud-eyebrow-gold">Point de départ</span>
      <h2 className="mt-1 font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--c-text)', fontSize: 22 }}>
        Comment souhaitez-vous constituer la matériauthèque ?
      </h2>
      <p className="text-[13.5px] mt-1" style={{ color: 'var(--c-text-2)' }}>
        Les sources se cumulent : commencez par les photos, ajoutez le CCTP quand il arrive.
      </p>
    </div>
    <div className="grid gap-4 md:grid-cols-3">
      {SOURCES.map((s) => {
        const locked = s.needsProject && !hasProject;
        const Icon = s.icon;
        return (
          <button
            key={s.id}
            type="button"
            disabled={locked || busy}
            onClick={() => onPick(s.id)}
            data-testid={`materialtheque-source-${s.id}`}
            className="hud-card hud-card-glass text-left relative group transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              padding: 22,
              minHeight: 220,
              border: s.accent ? '1px solid rgba(217,160,91,0.45)' : '1px solid var(--c-border)',
              boxShadow: s.accent ? '0 0 32px rgba(217,160,91,0.12)' : undefined,
            }}
          >
            <div className="flex items-start justify-between">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: 'var(--c-gold-soft)', border: '1px solid var(--c-border-accent)' }}>
                <Icon className="w-5 h-5" style={{ color: 'var(--c-gold)' }} strokeWidth={1.6} />
              </div>
              {locked ? (
                <Lock className="w-4 h-4" style={{ color: 'var(--c-text-faint)' }} />
              ) : (
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" style={{ color: 'var(--c-text-muted)' }} />
              )}
            </div>
            <span className="hud-eyebrow block mt-5" style={{ color: s.accent ? 'var(--c-gold)' : 'var(--c-text-muted)' }}>{s.eyebrow}</span>
            <h3 className="mt-1 font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--c-text)', fontSize: 17 }}>{s.title}</h3>
            <p className="mt-2 text-[12.5px] leading-relaxed" style={{ color: 'var(--c-text-2)' }}>{s.desc}</p>
            {locked && (
              <p className="mt-3 text-[11px]" style={{ color: 'var(--c-warning)' }}>Ouvrez la matériauthèque depuis un projet</p>
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default SourceChooser;
